// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../config/screen';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding-bottom: 1.5rem;
`;

export const CardContainer = styled.div`
  background-color: ${({ theme }) => theme.color.maintenanceCardList.backgroundColor};
  border: 1px solid ${({ theme }) => theme.color.maintenanceCardList.borderColor};
  border-radius: 8px;
  box-shadow:
    0px 4px 24px 0px ${({ theme }) => theme.color.maintenanceCardList.cardShadowColor},
    0px 2px 6px 0px ${({ theme }) => theme.color.maintenanceCardList.cardShadowColor};
  overflow: hidden;
  transition: all 0.2s ease-in-out;
`;

export const CardHeader = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 12px;
  padding: 0.75rem 1rem;

  &:hover {
    background-color: ${({ theme }) => theme.color.maintenanceCardList.hoverBackgroundColor};
  };
`;

export const CardTitleContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const CaretDownContainer = styled.div<{ isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease-in-out;

  svg {
    width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.color.maintenanceCardList.iconColor};
  };
`;

export const CardContentWrapper = styled.div<{ isExpanded: boolean }>`
  display: grid;
  grid-template-rows: ${({ isExpanded }) => (isExpanded ? '1fr' : '0fr')};
  transition: grid-template-rows 0.25s ease-in-out;
`;

export const CardContentInner = styled.div`
  overflow: hidden;
`;

export const CardContent = styled.div`
  border-top: 1px solid ${({ theme }) => theme.color.maintenanceCardList.contentBorderColor};
  padding: 1rem;
`;

export const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionSeparator = styled.div`
  border-top: 1px solid ${({ theme }) => theme.color.maintenanceCardList.contentBorderColor};
  margin: 4px 0;
`;

export const ColumnLabelsRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.color.maintenanceCardList.contentBorderColor};
  margin-bottom: 4px;
`;

export const SubItemRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
`;

export const SubItemLabel = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SubItemValue = styled.div`
  flex-shrink: 0;
  text-align: right;
`;

export const SubItemSecondaryFixedValue = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  flex-shrink: 0;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    width: 55px;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    width: 70px;
  };
`;

export const SubItemFixedValue = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 55px;
  flex-shrink: 0;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    width: 80px;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    width: 100px;
  };
`;
